import bedBugsIcon from '@/assets/icons/service-categories/bed-bugs.svg'
import cockroachesIcon from '@/assets/icons/service-categories/cockroaches.svg'
import insectControlIcon from '@/assets/icons/service-categories/insect-control.svg'
import pigeonsIcon from '@/assets/icons/service-categories/pigeons.svg'
import processionaryCaterpillarsIcon from '@/assets/icons/service-categories/processionary-caterpillars.svg'
import rodentControlIcon from '@/assets/icons/service-categories/rodent-control.svg'
import termitesIcon from '@/assets/icons/service-categories/termites.svg'
import waspsHornetsIcon from '@/assets/icons/service-categories/wasps-hornets.svg'
import { cn } from '@/lib/utils'

/** Canonical category names → Figma pest icons (TigerFlow Design node 4191:97770). */
const SERVICE_CATEGORY_ICONS: Record<string, string> = {
  'Guêpes / Frelons': waspsHornetsIcon,
  Cafards: cockroachesIcon,
  'Dératisation (Rats / Souris)': rodentControlIcon,
  'Punaises de lit': bedBugsIcon,
  Pigeons: pigeonsIcon,
  'Termites & Insectes xylophages': termitesIcon,
  'Chenilles processionnaires': processionaryCaterpillarsIcon,
  Désinsectisation: insectControlIcon,
  // Legacy English catalogue names
  'Wasps / Hornets': waspsHornetsIcon,
  Cockroaches: cockroachesIcon,
  'Rodent Control (Rats / Mice)': rodentControlIcon,
  'Bed Bugs': bedBugsIcon,
  'Termites & Wood-boring Insects': termitesIcon,
  'Processionary Caterpillars': processionaryCaterpillarsIcon,
  'General Insect Control': insectControlIcon,
}

function serviceCategoryIconSrc(name: string): string {
  return SERVICE_CATEGORY_ICONS[name.trim()] ?? insectControlIcon
}

export function ServiceCategoryIcon({
  name,
  className,
}: {
  name: string
  className?: string
}) {
  const src = serviceCategoryIconSrc(name)
  return (
    <img
      src={src}
      alt=''
      aria-hidden
      className={cn('size-4 shrink-0', className)}
    />
  )
}
